module.exports = __webpack_public_path__ + "img/1.ed26b422.jpg";